__webpack_require__.p = "/spcontent/bespoke/qotw/";